import { ReactNode, useCallback } from 'react';
import { joinClassNames } from '../../utils';
import styles from './FullScreenModal.module.scss';
import ReactModal from 'react-modal';
import { useFullscreen } from '../Fullscreen';

type FullScreenModalProps = Omit<ReactModal.Props, 'className' | 'appElement'> & {
  className?: string;
  rootElement?: string;
};

export const FullScreenModal = ({
  children,
  rootElement = '#root',
  className,
  ...props
}: FullScreenModalProps) => {
  const fullscreen = useFullscreen();
  const parentSelector = useCallback(
    () => (fullscreen.container instanceof HTMLElement ? fullscreen.container : document.body),
    [fullscreen.container]
  );

  ReactModal.setAppElement(rootElement);
  const classNames = joinClassNames(styles.fullScreenModal, className);
  return (
    <ReactModal className={classNames} parentSelector={parentSelector} {...props}>
      {children}
    </ReactModal>
  );
};
FullScreenModal.displayName = 'FullScreenModal';

type HeaderProps = { children: ReactNode };
const Header = ({ children }: HeaderProps) => <div className={styles.header}>{children}</div>;
Header.displayName = 'FullScreenModalHeader';
FullScreenModal.Header = Header;

type ToolbarProps = { children: ReactNode };
const Toolbar = ({ children }: ToolbarProps) => <div className={styles.toolbar}>{children}</div>;
Toolbar.displayName = 'FullscreenModalToolbar';
FullScreenModal.Toolbar = Toolbar;

type ContentProps = { children: ReactNode };
const Content = ({ children }: ContentProps) => <div className={styles.content}>{children}</div>;
Content.displayName = 'FullScreenModalContent';
FullScreenModal.Content = Content;

type FooterProps = { children: ReactNode };
const Footer = ({ children }: FooterProps) => <div className={styles.footer}>{children}</div>;
Footer.displayName = 'FullScreenModalFooter';
FullScreenModal.Footer = Footer;
